var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppliedTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "submitted-applicant-icon 1",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.175 4.2H6.825C6.2451 4.2 5.775 4.6701 5.775 5.25V15.225C5.775 15.8049 6.2451 16.275 6.825 16.275H14.175C14.7549 16.275 15.225 15.8049 15.225 15.225V5.25C15.225 4.6701 14.7549 4.2 14.175 4.2Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5 9.45C11.3698 9.45 12.075 8.74485 12.075 7.875C12.075 7.00515 11.3698 6.3 10.5 6.3C9.63015 6.3 8.925 7.00515 8.925 7.875C8.925 8.74485 9.63015 9.45 10.5 9.45Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.35 14.7C7.35 12.6703 8.76031 11.025 10.5 11.025C12.2397 11.025 13.65 12.6703 13.65 14.7",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.7 17.325C16.4397 17.325 17.85 15.9147 17.85 14.175C17.85 12.4353 16.4397 11.025 14.7 11.025C12.9603 11.025 11.55 12.4353 11.55 14.175C11.55 15.9147 12.9603 17.325 14.7 17.325Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.125 14.175L14.4375 15.4875L16.275 12.6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedTagIcon);
export default __webpack_public_path__ + "static/media/AppliedTagIcon.4ed0c7a4e8777e9cb9c082bcb8bdcd19.svg";
export { ForwardRef as ReactComponent };